import { Route, Routes } from "react-router-dom";

import { AdminShell } from "@/components/admin-shell";
import { DocumentTitle } from "@/components/document-title";
import { AppErrorBoundary } from "@/components/error-boundary";
import { PublicOnly, RequireAdmin } from "@/components/require-admin";
import { AppProviders } from "@/providers";
import { ForgotPasswordPage } from "@/pages/forgot-password";
import { LoginPage } from "@/pages/login";
import { MembersPage } from "@/pages/members";
import { NotFoundPage } from "@/pages/not-found";
import { OrderDetailPage } from "@/pages/order-detail";
import { OrdersPage } from "@/pages/orders";
import { OrganizerDetailPage } from "@/pages/organizer-detail";
import { OrganizersPage } from "@/pages/organizers";
import { OverviewPage } from "@/pages/overview";
import { PaymentSettingsPage } from "@/pages/payment-settings";
import { PayoutsPage } from "@/pages/payouts";
import { PlatformLogsPage } from "@/pages/platform-logs";
import { ReportsPage } from "@/pages/reports";
import { ResetPasswordPage } from "@/pages/reset-password";
import { TeamPage } from "@/pages/team";

export function App() {
  return (
    <AppProviders>
      <DocumentTitle />
      <AppErrorBoundary>
        <Routes>
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          <Route element={<PublicOnly />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          </Route>

          <Route element={<RequireAdmin />}>
            <Route element={<AdminShell />}>
              <Route path="/" element={<OverviewPage />} />
              <Route path="/organizers" element={<OrganizersPage />} />
              <Route path="/organizers/:id" element={<OrganizerDetailPage />} />
              <Route path="/orders" element={<OrdersPage />} />
              <Route path="/orders/:orderNumber" element={<OrderDetailPage />} />
              <Route path="/members" element={<MembersPage />} />
              <Route path="/payouts" element={<PayoutsPage />} />
              <Route path="/payment-settings" element={<PaymentSettingsPage />} />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/audit-logs" element={<PlatformLogsPage />} />
            </Route>
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AppErrorBoundary>
    </AppProviders>
  );
}
